import uniq from '../../../utils/uniq';
import actionTypes from '../../../actions/actionTypes';
import basicFeed from '../basicFeed';
import isEqual from 'lodash.isequal';

function updateFeed(oldFeed, action) {
  const { feed, type, normalizeResults = {} } = action;
  switch (type) {
    case actionTypes.FEED_RESET:
      return basicFeed;

    case actionTypes.FEED_REQUEST:
      const oldFilters = oldFeed.filterHistory.filter(f => !isEqual(f, feed.filter));
      const newFeed = {
        ...oldFeed,
        ...feed,
        isFetching: true,
        filterHistory: [feed.filter, ...oldFilters].filter(x => !!x).slice(0, 30),
      };

      if (!feed.hasOwnProperty('filter')) {
        delete newFeed.filter;
      }

      return newFeed;

    case actionTypes.FEED_REQUEST_FAILURE:
      return { ...oldFeed, isFetching: false };

    case actionTypes.FEED_REQUEST_SUCCESS:
      if (!isEqual(oldFeed.filter, feed.filter)) {
        return oldFeed;
      }
      const items = oldFeed.items || [];
      items[feed.pageNumber] = normalizeResults[feed.dataType] || [];

      return {
        ...oldFeed,
        total: feed.total,
        isFetching: false,
        items: items,
        lastUpdated: feed.receptionDate,
      };

    default:
      return oldFeed;
  }
}

export default (feed, action, state) => {
  if (!feed.id) return state;

  return {
    ...state,
    [feed.id]: updateFeed(state[feed.id] || basicFeed, action),
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/feeds/paginated/update.js